import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
// TODO: (D.K.) Necessary make refactoring of this part of the functionality is needed (to get rid of react-redux)
// eslint-disable-next-line no-restricted-imports
import QRCode from 'qrcode';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CONTAINED_VARIANT } from '@yme/atoms/button';
import { Dropdown } from '@yme/atoms/dropdown';
import { LanguageSelectorButton } from '@yme/atoms/language-selector-button';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, SM_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { TARGET_PAGE_SERVICE_ENDPOINT } from '@yme/common/endpoints';
import { useWindowSize } from '@yme/common/hooks';
import { getCartEntries } from '@yme/common/redux/cart/selectors';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS, ModalState } from '@yme/modals/constants';
import { getIsKioskVersion, getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { Network } from '@yme/services/network';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { reloadPage } from '@yme/utils/common';
import { COOKIE_EXPIRE_DAYS, PREFERRED_COUNTRY_COOKIE_NAME, PREFERRED_LANGUAGE_COOKIE_NAME, QR_CODE_WIDTH, } from './constants';
import { getPreparedCountryItems, getPreparedLanguageItems } from './helpers';
import { setActiveCountryItem, setActiveLanguageItem } from './redux/actions';
import { getLanguageSelectorProperties } from './redux/selectors';
import { ContentStyled, DropdownHint, LabelStyled, QrCodeWrapperStyled } from './styled';
export function LanguageSelector({ countries, labels, isMinified, isLight, onSelectorClick, }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const canvasRef = useRef(null);
    const { currentCountryConfig, buttonLabel, languages = [], navigationLink: homePagePath, buttonIcon, currentLanguage, } = useSelector(getLanguageSelectorProperties);
    const dispatch = useDispatch();
    const history = useHistory();
    const isRightToLeft = useSelector(getRTL);
    const cartEntries = useSelector(getCartEntries);
    const isKioskVersion = useSelector(getIsKioskVersion);
    const { t } = useTranslation();
    const { isInfiniteDesktopView } = useWindowSize();
    const preparedLanguages = getPreparedLanguageItems(languages);
    const qrUrl = `https://www.yamaha-motor.eu${homePagePath}`;
    const onOpen = () => {
        setIsOpen(true);
    };
    useEffect(() => {
        if (onSelectorClick && isOpen) {
            onSelectorClick();
        }
    }, [isOpen, onSelectorClick]);
    useEffect(() => {
        QRCode.toCanvas(canvasRef.current, qrUrl, {
            margin: 0,
            width: QR_CODE_WIDTH,
        });
    }, [isOpen, qrUrl]);
    const onHide = () => {
        dispatch(setActiveCountryItem(currentLanguage.country));
        dispatch(setActiveLanguageItem(currentLanguage.language));
        setIsOpen(false);
    };
    const onSubmit = () => {
        Cookies.set(PREFERRED_COUNTRY_COOKIE_NAME, currentCountryConfig.currentCountryRoot, {
            expires: COOKIE_EXPIRE_DAYS,
        });
        Cookies.set(PREFERRED_LANGUAGE_COOKIE_NAME, currentCountryConfig.currentLanguageRoot, {
            expires: COOKIE_EXPIRE_DAYS,
        });
        setIsOpen(false);
        if (currentCountryConfig.currentCountryRoot === currentLanguage.country &&
            currentCountryConfig.currentLanguageRoot === currentLanguage.language) {
            onHide();
        }
        else {
            setIsLoading(true);
            Network.get(TARGET_PAGE_SERVICE_ENDPOINT, {
                params: {
                    currentPagePath: window.location.pathname.split('.html')[0],
                    targetHomePagePath: homePagePath,
                    targetLocaleAndLanguage: `/${currentCountryConfig.currentCountryRoot}/${currentCountryConfig.currentLanguageRoot}`,
                },
            })
                .then((navLink) => {
                const hash = history.location.hash;
                const pathname = navLink.data;
                history.push({
                    pathname,
                    hash: pathname.includes('/pdp') ? hash : '',
                });
            })
                .catch(() => {
                history.push({
                    pathname: homePagePath || '',
                });
            })
                .finally(() => {
                // because we unable to change ROOT model in runtime (likely break analytics and other stuff)
                // we need to reload page to apply new language
                reloadPage();
            });
        }
    };
    const onSubmitWithNonEmptyCart = () => {
        setIsOpen(false);
        dispatch(setIsModalShowed({
            type: MODALS.ALERT_MESSAGE_MODAL,
            data: {
                state: ModalState.WARNING,
                title: t('languageSelector_changeAlertTitle_label'),
                content: t('languageSelector_changeAlertText_label'),
                primaryButtonContent: t('common_confirm_button'),
                secondaryButtonContent: t('common_cancel_button'),
                modalSize: SM_MODAL,
                isSubmitButtonFullWidth: !isInfiniteDesktopView,
                callback: onSubmit,
            },
        }));
    };
    const onChangeActiveCountryItem = (value) => {
        dispatch(setActiveCountryItem(value));
    };
    const onChangeActiveLanguageItem = (value) => {
        dispatch(setActiveLanguageItem(value));
    };
    const modalFooter = (React.createElement(ModalWindowFooter, { isCancelButton: true, isSubmitButton: true, onSubmit: cartEntries.length ? onSubmitWithNonEmptyCart : onSubmit, onHide: onHide, submitButtonLabel: labels.common_confirm_button, cancelButtonLabel: labels.common_cancel_button, isBtnsWidthStyleReset: true }));
    const Modal = (React.createElement(StaticModalWindow, { isRightToLeft: isRightToLeft, staticModalSize: SM_MODAL, title: labels.languageSelector_header_label, onHide: onHide, footerComponent: modalFooter },
        React.createElement(ContentStyled, { zIndex: Z_INDEX.level2 },
            React.createElement(LabelStyled, { htmlFor: "country" }, labels.languageSelector_country_label),
            React.createElement(Dropdown, { id: "country" // TODO: (D.K.) Need implement dynamic id for this component
                , key: "country", hasAutocomplete: true, onChange: onChangeActiveCountryItem, items: getPreparedCountryItems(countries), activeItem: currentCountryConfig.currentCountryRoot, inputPlaceholder: labels.languageSelector_dropdown_placeholder, isRightToLeft: isRightToLeft, className: "items-with-icons" }),
            React.createElement(DropdownHint, { as: "p" }, labels.languageSelector_country_hint)),
        React.createElement(ContentStyled, { zIndex: Z_INDEX.level1 },
            React.createElement(LabelStyled, { htmlFor: "language" }, labels.languageSelector_language_label),
            React.createElement(Dropdown, { id: "language" // TODO: (D.K.) Need implement dynamic id for this component
                , key: "language", onChange: onChangeActiveLanguageItem, items: preparedLanguages, isDisabled: preparedLanguages.length <= 1, activeItem: currentCountryConfig.currentLanguageRoot, isRightToLeft: isRightToLeft }))));
    const ModalKiosk = (React.createElement(StaticModalWindow, { isRightToLeft: isRightToLeft, staticModalSize: MD_MODAL, title: t('languageSelector_kiosk_header_label'), onHide: onHide, footerComponent: React.createElement(ModalWindowFooter, { isCancelButton: true, cancelButtonVariant: CONTAINED_VARIANT, onHide: onHide, cancelButtonLabel: t('common_close_label'), isBtnsWidthStyleReset: true }) },
        React.createElement(ContentStyled, { zIndex: Z_INDEX.level2 },
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, t('languageSelector_kiosk_message')),
            React.createElement(QrCodeWrapperStyled, null,
                React.createElement("canvas", { ref: canvasRef })))));
    const ModalWindow = isKioskVersion ? ModalKiosk : Modal;
    return (React.createElement(React.Fragment, null,
        React.createElement(LanguageSelectorButton, { onClick: onOpen, isRightToLeft: isRightToLeft, iconComponent: buttonIcon, label: !isMinified ? buttonLabel : '', isMinified: isMinified, isLight: isLight, hasIcon: true }),
        React.createElement(SpinnerLoader, { isLoading: isLoading, fullWidth: true }),
        isOpen && ModalWindow));
}
